import type { Api } from './Api';
import { mockApi } from './mockApi';
import { supabaseApi } from './supabaseApi';
import { runtimeConfig } from '../config/runtimeConfig';

// Misma idea que createBotApi de apps/web: elige el adaptador por runtimeConfig.
export function createApi(): Api {
  return runtimeConfig().apiMode === 'supabase' ? supabaseApi : mockApi;
}
